import type { SubscriptionMe } from '../model/subscription.types';

export function isExpiredPaid(subscription: SubscriptionMe | null | undefined): boolean {
    return subscription?.status === 'CANCELED' && !subscription.isTrial;
}
